/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { PagesSystemAuthComponent } from './auth/auth.component';
import { PagesSystemRouterComponent } from './router/router.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
    ],
    declarations: [
        PagesSystemRouterComponent,
        PagesSystemAuthComponent,
    ],
    exports: [
        PagesSystemRouterComponent,
        PagesSystemAuthComponent,
    ],
})
export class PagesSystemModule { }
